/* @flow */

import React from 'react';
import { Form, Segment, Button, Divider } from 'semantic-ui-react';
import OrderDropdown from 'shared/components/OrderDropdown';

type Props = {
  image: GalleryContentImage,
  imageCount: number,
  onTitleChange: (title: string) => void,
  onOrderChange: (link: GalleryContentImage, order: number) => void,
  onDelete: (link: GalleryContentImage) => void,
};

const GalleryImageForm = ({
  image,
  imageCount,
  onTitleChange,
  onOrderChange,
  onDelete,
}: Props) => {
  const onChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onTitleChange(event.target.value);
    }
  };

  const changeImageOrder = newOrder => onOrderChange(image, newOrder);
  const deleteImage = () => onDelete(image);

  return (
    <div>
      <Form>
        <Form.Input
          label="Titre"
          value={image.title || ''}
          onChange={onChange}
        />
      </Form>
      <Divider />
      <Segment basic>
        <OrderDropdown
          value={image.order}
          orderCount={imageCount}
          onChange={changeImageOrder}
        />
        <Button
          onClick={deleteImage}
          labelPosition="right"
          icon="remove"
          content="Supprimer"
          color="red"
          floated="right"
        />
      </Segment>
    </div>
  );
};

export default GalleryImageForm;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/gallery/GalleryImageForm.js